// extracted by mini-css-extract-plugin
export var modal = "_gi-0";